import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'

export const setEditable = createAction(ActionTypes.EDITABLE_SET)
export const setAddressFormOpen = createAction(ActionTypes.IS_ADDRESS_FORM_OPEN_SET)
export const fieldsChangeAction = createAction(ActionTypes.CARD_FIELDS_CHANGE)
export const setBillingAddress = createAction(ActionTypes.BILLING_ADDRESS_SET)
export const setCardInfo = createAction(ActionTypes.CARD_INFO_SET)
export const setStripeFieldsValid = createAction(ActionTypes.STRIPE_FIELDS_VALID_SET)
export const toggleNeedSaveCard = createAction(ActionTypes.NEED_SAVE_CARD_SET)

export const resetCardForEdit = () => (dispatch) => {
    dispatch(setEditable(true))
    dispatch(setAddressFormOpen(false))
    dispatch(setCardInfo({
        cardBrand: '',
        cardNumber: '',
        holderName: '',
        expiredMonth: '',
        expiredYear: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        state: '',
    }))
}

export const setCardInfoFromData = (data) => (dispatch) => {

    dispatch(setCardInfo({
        cardBrand: data.brand,
        cardNumber: data.lastFourDigits,
        holderName: data.name,
        expiredMonth: data.expiredMonth,
        expiredYear: data.expiredYear,
        address: data.address,
        city: data.city,
        zip: data.zip,
        country: data.country,
        state: data.state,
    }))
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/actions.js